module.exports = {"button":"Close","rodoStart":"I confirm that I have read","rodoEnd":"the information clause of Sagiton Sp. z o.o.","dataStart":"Consent to","dataEnd":"data processing for contact purposes","marketingEnd":"data processing for marketing purposes"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en/consent/common.json
// module id = 186
// module chunks = 0